import React from "react";

function PrimaryButton({ children, className, ...props }: PrimaryPropsType) {
  return (
    <button
      type="button"
      className={`text-white  bg-orangeLight 
                    rounded-[4px] lg:rounded px-8  shadow-inset lg:text-2xl text-3xl
                    min-h-[48px] min-w-[48px] lg:min-h-[56px] lg:min-w-[56px]
                    lg:py-5 py-7	${className} `}
      {...props}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;
type PrimaryPropsType = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;
